import { useDynamicConfig, useStatsigClient } from '@statsig/react-bindings';
import { SMPLandingPage } from './SMPLandingPage';
import { SMPMaintenancePage } from './SMPMaintenancePage';
import { SMPLandingPageSkeleton } from './SMPLandingPageSkeleton';

export const SMP = () => {
  const { client } = useStatsigClient();
  const isStatsigReady = client.loadingStatus === 'Ready';

  const config = useDynamicConfig('public_config');
  const maintenanceMode = config.get('smp_maintenance_mode', false);

  if (!isStatsigReady) {
    return <SMPLandingPageSkeleton />;
  }

  if (maintenanceMode) {
    return <SMPMaintenancePage />;
  }

  return <SMPLandingPage />;
};
